import axios from 'axios';

export const getRegionURLString = (region) => {
	switch(region) {
		case 'B':
			return 'burgenland';
		case 'K':
			return 'kaernten';
		case 'NÖ':
			return 'noe';
		case 'OÖ':
			return 'ooe';
		case 'S':
			return 'salzburg';
		case 'St':
			return 'steiermark';
		case 'T':
			return 'tirol';
		case 'V':
			return 'vorarlberg';
		case 'W':
			return 'wien';
		default:
			return '';
	}
}

export const getRegionShortName = (region) => {
	switch(region) {
		case 'burgenland':
			return 'B';
		case 'kaernten':
			return 'K';
		case 'noe':
			return 'NÖ';
		case 'ooe':
			return 'OÖ';
		case 'salzburg':
			return 'S';
		case 'steiermark':
			return 'St';
		case 'tirol':
			return 'T';
		case 'vorarlberg':
			return 'V';
		case 'wien':
			return 'W';
		default:
			return '';
	}
}

export const getRegionFullName = (region) => {
	switch(region) {
		case 'burgenland':
			return 'Burgenland';
		case 'kaernten':
			return 'Kärnten';
		case 'noe':
			return 'Niederösterreich';
		case 'ooe':
			return 'Oberösterreich';
		case 'salzburg':
			return 'Salzburg';
		case 'steiermark':
			return 'Steiermark';
		case 'tirol':
			return 'Tirol';
		case 'vorarlberg':
			return 'Vorarlberg';
		case 'wien':
			return 'Wien';
		default:
			return '';
	}
}

export const getData = (year, region) => {
	const token = 'vPQzovwdrzZJ7LDGaMeiCKi3W';

	let url = 'https://www.feiertage-oesterreich.at/api/dates/?token='+token+'&region='+getRegionShortName(region)+'&year=' + year;
	//let url = 'https://www.feiertage-oesterreich.at/api/dates/?token='+token+'&year=' + year;

	return new Promise(function(resolve, reject) {

		axios.post(url)
			.then((response) => {
				resolve(response.data);
			})
			.catch((error) => {
				reject(Error('PROMISE ERROR: getData' + error));
			});
	});
}

export const camelize = (string) => {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 *
 day:
 The representation of the day.
 Possible values are "numeric", "2-digit".
 weekday:
 The representation of the weekday.
 Possible values are "narrow", "short", "long".
 year:
 The representation of the year.
 Possible values are "numeric", "2-digit".
 month:
 The representation of the month.
 Possible values are "numeric", "2-digit", "narrow", "short", "long".
 hour:
 The representation of the hour.
 Possible values are "numeric", "2-digit".
 minute: The representation of the minute.
 Possible values are "numeric", "2-digit".
 second:
 The representation of the second.
 Possible values are "numeric", 2-digit".
 */
export const formatDate = (date, options = {}, locale = "") => {

	return date.toLocaleDateString(
		(locale) ? locale : "de-AT",
		{
			weekday: options.weekday,
			year: (options.year) ? options.year : 'numeric',
			month: (options.month) ? options.month : '2-digit',
			day: (options.day) ? options.day : '2-digit'

		}
	);
}


// WEBPACK FOOTER //
// ./src/components/Helper/functions.js